import type { TFunction } from "i18next";
import type { NotificationsDropdownLabels } from "@weco/suite-chrome";

/** Strings for the bell's panel (suite-chrome takes labels, not i18next). */
export function notificationPanelLabels(t: TFunction): NotificationsDropdownLabels {
  return {
    markAllRead: t("notifications.markAllRead"),
    loading: t("notifications.loading"),
    error: t("notifications.error"),
    retry: t("notifications.retry"),
    reconnecting: t("notifications.reconnecting"),
    loadMore: t("notifications.loadMore"),
  };
}
